import { Button, Chip, Tooltip } from '@mui/material';
import { dateHeader, formatCellDate } from '../../../utils/columns/timeModeCell';
import { EnhancedEncryption, OpenInNew } from '@mui/icons-material';

const makeAppUserColumn = (
  resetPassword: { (id: string): Promise<void>; (arg0: any): void },
  manageUserPermissions: { (id: string): void; (arg0: any): void },
  unLock: { (id: string): Promise<void>; (arg0: any): void },
  openScopePopup: { (id: string): void; (arg0: any): void }
) => {
  return [
    {
      id: 'manage',
      header: '',
      accessorKey: 'manage',
      enableColumnFilter: false,
      sortable: false,
      size: 30,
      cell: ({ row }) => (
        <Tooltip title='Configure permissions' disableInteractive>
          <EnhancedEncryption fontSize='small' cursor='pointer' onClick={() => manageUserPermissions(row.original.id)} />
        </Tooltip>
      ),
    },
    {
      id: 'manageInNewTab',
      header: '',
      accessorKey: 'manageInNewTab',
      enableColumnFilter: false,
      sortable: false,
      size: 30,
      cell: ({ row }) => (
        <a href={'/users/' + row.original.id} rel='noreferrer' target='_blank'>
          <Tooltip title='Configure in new tab' disableInteractive>
            <OpenInNew fontSize='small' cursor='pointer' />
          </Tooltip>
        </a>
      ),
    },
    {
      header: 'Firstname',
      accessorKey: 'firstName',
      enableColumnFilter: true,
      size: 110,
    },
    {
      header: 'Lastname',
      accessorKey: 'lastName',
      enableColumnFilter: true,
      size: 150,
    },
    {
      header: 'Full name',
      accessorKey: 'fullName',
      enableColumnFilter: true,
      size: 150,
    },
    {
      header: 'Email',
      accessorKey: 'email',
      enableColumnFilter: true,
      size: 250,
    },
    {
      header: 'Station',
      accessorKey: 'location',
      enableColumnFilter: true,
      sortable: true,
      size: 150,
    },
    {
      header: 'Roles',
      accessorKey: 'roles',
      enableColumnFilter: true,
      sortable: false,
      size: 80,
      cell: ({ row }) => (
        <Tooltip
          placement='left'
          title={
            <div>
              {row.original.roles.map((x, idx) => (
                <div key={idx}>{x.name}</div>
              ))}
            </div>
          }
        >
          <span>{row.original.roles.map((x) => x.name).join(', ')}</span>
        </Tooltip>
      ),
    },
    {
      header: 'Scope',
      size: 150,
      cell: ({ row }) => (
        <Button variant='text' style={{ textDecoration: 'underline' }} size='small' onClick={() => openScopePopup(row.original.id)}>
          View Scope
        </Button>
      ),
    },
    {
      header: dateHeader('Last login'),
      accessorKey: 'lastLoginDateTime',
      size: 150,
      cell: ({ row, table }) => formatCellDate(table, row.original.lastLoginDateTime),
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 150,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 150,
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
    {
      header: 'Locked',
      accessorKey: 'locked',
      enableColumnFilter: false,
      sortable: false,
      size: 80,
      cell: ({ row }) =>
        row.original.isLocked && (
          <Button
            variant='contained'
            color='error'
            size='small'
            onClick={() => unLock(row.original.id)}
            style={{ paddingTop: 6, height: 20, cursor: 'pointer', fontSize: 'x-small' }}
          >
            Unlock
          </Button>
        ),
    },
    {
      header: 'Active',
      accessorKey: 'isDisabled',
      enableColumnFilter: false,
      sortable: false,
      size: 80,
      cell: ({ row }) =>
        row.original.isDisabled ? <Chip size='small' label='Disabled' color='error' /> : <Chip size='small' label='Active' color='success' />,
    },
    {
      header: 'Password reset',
      accessorKey: null,
      sortable: false,
      size: 150,
      cell: ({ row }) => <Chip color='primary' size='small' variant='filled' onClick={() => resetPassword(row.original.id)} label='Reset password' />,
    },
  ] as Array<any>;
};
export default makeAppUserColumn;
